<div class="fav-grid-buttons">
  <div class="fav-grid-buttons-container">
    <span [ngClass]="['fav-grid-button', activeView === 'CVT' ? 'active' : '']" (click)="switchTo('CVT')">{{
      'favGrid.count' | translate
    }}</span>
    <span [ngClass]="['fav-grid-button', activeView === 'LVT' ? 'active' : '']" (click)="switchTo('LVT')">{{
      'favGrid.list' | translate
    }}</span>
  </div>
</div>

<div #fgiListElt class="fav-grid-items" [ngStyle]="{ display: activeView === 'LVT' ? 'flex' : 'none' }">
  @if (activeView === 'LVT') {
    <cdk-virtual-scroll-viewport class="fav-grid-virtualScroll" itemSize="40" [maxBufferPx]="240" [minBufferPx]="240">
      <div
        *cdkVirtualFor="let item of items$ | async; trackBy: trackByFn"
        class="fav-grid-item"
        (click)="openTab($event, item)">
        {{ item.displayedName }}
      </div>
    </cdk-virtual-scroll-viewport>
  }
</div>

@if (activeView === 'CVT') {
  <div
    #widgetCircularProgress
    aria-hidden="true"
    class="circular-progress"
    data-cy="openInWindow"
    [life]="3000"
    pTooltip="{{ widget.alertLevel || widget.normalLevel ? percent + ' %' : (result | number: numberFormat) }}"
    (click)="openTab($event)">
    <div class="progress-value">
      <span [style.color]="bgColor">
        {{ result | number: numberFormat : lang }}
        @if (this.currency) {
          <i class="progress-value-currency" [style.color]="bgColor">
            {{ this.currency }}
          </i>
        }
      </span>
    </div>
  </div>
}
